module.exports = __webpack_public_path__ + "img/logo_y_slogan.fdcaaf40.png";